import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {LegacyAssaySchemaType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {DefaultSchemaCollaboratorsConfigurationSchemaType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {SCHEMA_TYPE_NAME} from 'results/assay-schemas/AssaySchemaConstants';
import SchemaWithOrgPermissionsCreateFlow from 'schemas/SchemaWithOrgPermissionsCreateFlow';
import {capitalize} from 'util/NameUtil';

import {AssaySchemaEditorQuery} from './__generated/AssaySchemaEditorQuery';
import AssaySchemaMetadataSettings, {
  AssaySchemaMetadataSettingsProps,
  createAssaySchema,
} from './AssaySchemaMetadataSettings';

type Organization = NonNullable<AssaySchemaEditorQuery['currentTenantOrganizations']>[number];

export interface AssaySchemaCreateFlowProps extends AssaySchemaMetadataSettingsProps {
  organizations: Array<Organization>;
}

export default function AssaySchemaCreateFlow(props: AssaySchemaCreateFlowProps): JSX.Element {
  const defaultSchemaCollaboratorsSchemaType =
    props.schemaType === LegacyAssaySchemaType.ASSAY_RESULT
      ? DefaultSchemaCollaboratorsConfigurationSchemaType.RESULT
      : DefaultSchemaCollaboratorsConfigurationSchemaType.RUN;
  function renderMetadataSettings(handleNext: () => void): JSX.Element {
    return <AssaySchemaMetadataSettings {...props} handleNext={handleNext} />;
  }
  return (
    <SchemaWithOrgPermissionsCreateFlow
      createSchema={(collaborators) => {
        createAssaySchema(props, collaborators);
      }}
      defaultSchemaCollaboratorsSchemaType={defaultSchemaCollaboratorsSchemaType}
      metadataTitle={`${capitalize(SCHEMA_TYPE_NAME[props.schemaType])} Settings`}
      isSchemaPermissionsEnabled={BenchlingConfig.PERMISSIONS_ENABLE_ASSAY_SCHEMA_PERMISSIONS}
      ownerId={props.ownerId}
      organizations={props.organizations}
      renderMetadataSettings={renderMetadataSettings}
    />
  );
}
